import { Draft } from '@reduxjs/toolkit';

import { IManufacturerData } from '../../index';

function importSpreadsheetSuccess(draft: Draft<IManufacturerData>) {
  draft.importSpreadsheet.config.isLoading = false;
}

export default importSpreadsheetSuccess;
